if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends customElements.get('card-product-slider') {
    constructor() {
      super();

      this.dotsList = this.querySelector('.js-dots-list');
      this.carouselDotsList = this.querySelector('.js-carousel-dots');
      
      this.sliderOptions.breakpoints = {
        750: {
          slidesPerView: 1,
          spaceBetween: 72
        },
        990: {
          spaceBetween: 100
        },
        1100: {
          spaceBetween: 130
        },
        1200: {
          spaceBetween: 156
        }
      };

      this.initSlider(this.querySelector('.js-slider'));
      this.attachDotsListeners();
    }

    connectedCallback() {}

    attachDotsListeners() {
      // Image dots listeners
      if (this.dotsList) {
        this.dotsList.addEventListener('click', e => {
          const isBtn = e.target.classList.contains('js-btn');

          if (!isBtn) {
            return;
          }

          e.preventDefault();

          const btn = e.target;
          const isCurrent = btn.classList.contains('is-current');

          if (isCurrent) {
            return;
          }

          const btnIndex = +btn.dataset.index;

          this.updateAllDots(btnIndex);
          this.slider.slideTo(btnIndex, 300);
        });
      }

      // Carousel dots listeners
      if (this.carouselDotsList) {
        this.carouselDotsList.addEventListener('click', e => {
          const isBtn = e.target.classList.contains('js-carousel-btn');

          if (!isBtn) {
            return;
          }

          e.preventDefault();

          const btn = e.target;
          const isCurrent = btn.classList.contains('is-current');

          if (isCurrent) {
            return;
          }

          const btnIndex = +btn.dataset.index;

          this.updateAllDots(btnIndex);
          this.slider.slideTo(btnIndex, 300);
        });
      }

      // Slider change event
      this.slider?.on('slideChange', e => {
        const sliderIndex = e.realIndex;
        this.updateAllDots(sliderIndex);
      });
    }

    updateAllDots(activeIndex) {
      // Update image dots
      if (this.dotsList) {
        const imageDots = this.dotsList.querySelectorAll('.js-btn');
        imageDots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('is-current');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-current');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }

      // Update carousel dots
      if (this.carouselDotsList) {
        const carouselDots = this.carouselDotsList.querySelectorAll('.js-carousel-btn');
        carouselDots.forEach((dot, index) => {
          if (index === activeIndex) {
            dot.classList.add('is-current');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-current');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}